import { render, staticRenderFns } from "./ProductsFrame.vue?vue&type=template&id=7e32143a&scoped=true"
import script from "./ProductsFrame.vue?vue&type=script&lang=js"
export * from "./ProductsFrame.vue?vue&type=script&lang=js"
import style0 from "./ProductsFrame.vue?vue&type=style&index=0&id=7e32143a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e32143a",
  null
  
)

export default component.exports